type MessagePayload = {
  action: string;
  data?: Record<string, any>;
};

export function sendMessageToReactNativeApp(
  { action, data }: MessagePayload,
  others: Record<string, any> = {}
): void {
  if (!action || typeof action !== "string") {
    throw new Error("Action must be a non-empty string");
  }

  const message = {
    action,
    ...(data && { data }),
    ...others,
  };

  if (typeof (window as any).ReactNativeWebView?.postMessage === "function") {
    (window as any).ReactNativeWebView.postMessage(JSON.stringify(message));
  } else {
    console.warn("window.ReactNativeWebView.postMessage is not a function");
  }
}
